import { EntityTypeFilterValue } from "../../../../legacy/types/companyFilter";
import { CompanyTypeOption } from "../constants";

export const getCompanyTypeOption = (value: EntityTypeFilterValue) => {
  if (value?.isGhq) {
    return CompanyTypeOption.GHQ;
  } else if (value?.isGp) {
    return CompanyTypeOption.CP;
  } else if (value?.isDp) {
    return CompanyTypeOption.DP;
  } else {
    return CompanyTypeOption.ALL;
  }
};

export const getCompanyTypeLabel = (value: EntityTypeFilterValue) => {
  let label = "All";

  if (value.isGhq) {
    label = "Global Headquarters (GHQ)";
  } else if (value.isGp) {
    label = "Corporate Parent";
  } else if (value.isDp) {
    label = "Domestic Parent";
  }

  return label;
};

export const getCompanyTypeForQuery = (
  value: EntityTypeFilterValue
): string | undefined => {
  if (value?.isGhq) {
    return "GHQ";
  } else if (value?.isGp) {
    return "GP";
  } else if (value?.isDp) {
    return "DP";
  }
  return undefined;
};
